<template>
    <div class="filebrowser appear">
        <div style="position: absolute; left: 50%; z-index: 999; width: 80%; max-width: 600px; min-width: 350px; top: 50%; transform: translate(-50%, -50%); background-color: #ffffff; padding: 20px 30px; border-radius: 15px; font-size: 14px; text-align: left;"> 
            <div class="input-block form-group mb-3">
                <label>Соц. сеть:</label>
                <select
                    v-model="type"
                    class="form-control"
                >
                    <option
                        v-if="type === null"
                        disabled
                        value=""
                    >
                        Выберите соц. сеть
                    </option>
                    <option
                        v-for="(option, value) of linktypes" 
                        :key="value"
                        :value="value"
                    >
                        {{ option }}
                    </option>
                </select>
            </div>
            <template v-if="type">
                <div class="input-block form-group mb-3">
                    <label>Размер иконки:</label>
                    <select
                        v-model="size"
                        class="form-control"
                    >
                        <option value="64">
                            64x64
                        </option>
                        <option value="48">
                            48x48
                        </option>
                        <option value="32">
                            32x32
                        </option>
                        <option value="24">
                            24x24
                        </option>
                    </select>
                </div>
                <div class="input-block form-group mb-3">
                    <label class="block">Стиль иконки:</label>
                    <br>
                    <div class="btn-group">
                        <a
                            v-for="i in iconThemes"
                            :key="i.src"
                            class="social-icon-thumbnail"
                            href="#"
                            :class="{'selected': icon && i.src === icon.src}"
                            @click="setIcon(i)"
                        >
                            <div class="social-btn-label">{{ i.name }}</div>
                            <img :src="baseUrl+i.src">
                        </a>
                        <a
                            class="social-icon-thumbnail"
                            title="Загрузить изображение"
                            href="#"
                            :class="{'selected': icon === null && customIcon }"
                            @click="setIcon(null)"
                        >
                            <span
                                class="btn btn-primary social-upload-btn"
                                @click="imageData.chooseFile()"
                            >
                                Загрузить
                            </span>
                            <span>
                                <croppa 
                                    v-model="imageData"
                                    accept="image/*"
                                    placeholder="Выберите изображение"
                                    :style="{'visibility': imageData ? 'visible': 'hidden'}"
                                    :initial-image="customIcon ? customIcon.image : null"
                                    :height="64"
                                    :width="64"
                                    :quality="2"
                                    :canvas-color="'transparent'"
                                    :file-size-limit="4*1024*1024"
                                    :disabled="false"
                                    :prevent-white-space="true"
                                    :auto-sizing="false"
                                    :zoom-speed="10"
                                    :show-remove-button="false"
                                    @click="setIcon(null)"
                                    @new-image="saveOriginalImage"
                                    @init="restoreImageMetadata"
                                    @initial-image-loaded="restoreImageMetadata"
                                 />
                            </span>
                        </a>
                    </div>
                </div>

                <div
                    v-if="dialogtype === 'share' && ['vk'].includes(type)"
                    class="input-block form-group mb-3"
                >
                    <label>Заголовок:</label>
                    <ul class="nav nav-pills float-right">
                        <li class="nav-item">
                            <a
                                style="padding: 0 10px; box-shadow: none;"
                                class="nav-link"
                                href="#"
                                :class="{'active': titleType === 'auto'}"
                                @click.prevent="setTitleType('auto')"
                            >
                                Тема письма 
                            </a>
                        </li>
                        <li class="nav-item">
                            <a
                                style="padding: 0 10px; box-shadow: none;"
                                class="nav-link"
                                href="#" 
                                :class="{'active': titleType === 'user'}"
                                @click.prevent="setTitleType('user')"
                            >
                                Задать вручную 
                            </a>
                        </li>
                    </ul>
                    <input
                        v-if="titleType === 'user'"
                        v-model="title"
                        class="form-control"
                        placeholder="Текст заголовка"
                    >
                </div>

                <div
                    v-if="dialogtype === 'share' && ['vk', 'twitter'].includes(type)"
                    class="input-block form-group mb-3"
                >
                    <label>Описание:</label>
                    <textarea
                        v-model="description"
                        placeholder="Текст описания"
                        class="form-control"
                    />
                </div>

                <div
                    v-if="dialogtype === 'share' && type === 'twitter'"
                    class="input-block form-group mb-3"
                >
                    <label>Хэштеги:</label>
                    <v-select 
                        ref="vselect"
                        v-model="hashtags"
                        placeholder=""
                        :multiple="true"
                        :seachable="false"
                        :filterable="false"
                        :no-drop="true"
                        :select-on-tab="true"
                        :close-on-select="false"
                        :taggable="true"
                        @keyup.native="selectTagOnSpacebar"
                        @input="sanitizeHashTags"
                    />
                </div>

                <div class="input-block form-group mb-3">
                    <label
                        :class="{'mb-0': urlType === 'auto'}"
                    >
                        Ссылка:
                    </label>
                    <ul
                        v-if="dialogtype === 'share'"
                        class="nav nav-pills float-right"
                    >
                        <li class="nav-item">
                            <a
                                style="padding: 0 10px; box-shadow: none;"
                                class="nav-link"
                                href="#"
                                :class="{'active': urlType === 'auto'}"
                                @click.prevent="setUrlType('auto')"
                            >
                                Веб-версия
                            </a>
                        </li>
                        <li class="nav-item">
                            <a
                                style="padding: 0 10px; box-shadow: none;"
                                class="nav-link"
                                href="#"
                                :class="{'active': urlType === 'user'}"
                                @click.prevent="setUrlType('user')"
                            >
                                Задать вручную 
                            </a>
                        </li>
                    </ul>
                    <url-input 
                        v-if="urlType === 'user'"
                        placeholder="Введите url-адрес"
                        :val="url"
                        @change="updateURL"
                    />
                </div>
            </template>
            <hr>
            <div class="form-group">
                <span v-if="type">
                    <span
                        v-if="formIsValid()"
                        style="padding: .375rem .75rem;"
                        class="btn btn-primary"
                        @click="save"
                    >
                        <span class="fa fa-save" /> Сохранить
                    </span>
                    <span
                        v-else
                        style="padding: .375rem .75rem;"
                        class="btn btn-primary disabled"
                    >
                        <span class="fa fa-save" /> Сохранить
                    </span>
                </span>
                <span
                    style="padding: .375rem .75rem;"
                    class="btn btn-danger float-right"
                    @click="cancel"
                >
                    <span class="fa fa-times" /> Отмена
                </span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'SocialDialog',
        props: {
            item: {
                type: Object,
                default: function(){ return {} },
            },
            index: {
                type: Number,
                default: null,
            },
            dialogtype: {
                type: String,
                default: 'share',
            },
            linktypes: {
                type: Object,
                default: function(){ return {} },
            },
            lastsize: {
                type: Number,
                default: null,
            }
        },
        data: function(){
            return {
                type: this.item.type || null,
                icon: this.item.icon || null,
                size: this.item.size || this.lastsize || 64,
                customIcon: this.item.customIcon || null,
                title: this.item.title || null,
                titleType: 'auto',
                url: this.item.url || '',
                urlType: this.dialogtype === 'share' ? 'auto' : 'user',
                description: this.item.description || null,
                hashtags: this.item.hashtags || [],
                imageData: null,
                iconThemes: [],
                baseUrl: '/',
            }
        },
        watch: {
            urlType: function() {
            },
            type: function() {
                this.updateThemes();
            }
        },
        mounted: function() {
            this.updateThemes();
            this.baseUrl = this.$root.baseUrl;
        },
        methods: {
            selectTagOnSpacebar(e) {
                if (e.key === ' ' || e.key === 'Spacebar'){
                    if (this.$refs.vselect.$refs.search.value.replace(/\ /g, '').replace(/#/g, '').length > 0) {
                        this.$refs.vselect.select(
                            this.$refs.vselect.$refs.search.value.replace(/\ /g,'').replace(/#/g, '')
                        );
                    }
                }
            },
            sanitizeHashTags(tags) {
                sanitizedTags = [];
                for(let x of tags) {
                    sanitizedTags.push('#' + x.replace(/\ /g, '').replace(/#/g, ''));
                }
                this.hashtags = sanitizedTags.filter((v, i, a) => a.indexOf(v) === i);
            },
            updateURL(value, valid) {
                if (value && valid) {
                    this.url = value;
                }
            },
            setUrlType(value) {
                this.urlType = value;
            },
            setTitleType(value) {
                this.titleType = value;
            },
            updateThemes() {
                if (this.type) {
                    let iconExists = false;
                    this.iconThemes = [];
                    for (let x of this.$root.templates.filter(x => x.id == this.$root.template)[0]['icons']) {
                        for (let icon of x.icons) {
                            if (icon.name === this.type) {
                                this.iconThemes.push({name: x.name, src: icon.src});
                                if (this.icon && x.name === this.icon.name) {
                                    this.icon = {name: x.name, src: icon.src};
                                    iconExists = true;
                                }
                            }
                        }
                    }
                    if (!iconExists) {
                        this.icon = null;
                    }
                }
            },
            setIcon(icon) {
                if (icon) {
                    this.icon = icon; 
                } else {
                    this.icon = null;
                }
            },
            imageHasChanged: function() {
                if (!this.customIcon.hasOwnProperty('metadata')) {
                    return true;
                }
                const keys = ['startX', 'startY', 'scale', 'orientation'];
                const stored = JSON.parse(this.customIcon.metadata);
                const current = this.imageData.getMetadata();
                for (let i in keys) {
                    if (stored[keys[i]] != current[keys[i]]) {
                        return true;
                    }
                }
                return false;
            },
            restoreImageMetadata: function() {
                if (this.customIcon && this.imageData) {
                    this.imageData.applyMetadata(JSON.parse(this.customIcon.metadata));
                }
            },
            saveOriginalImage: function() {
                let component = this;
                let url = '/upload/';

                this.$root.lock();
                this.setIcon(null);

                let postdata = {
                    file: this.imageData.originalImage.src
                }

                if (component.$root.siteId) {
                    url = '/upload/' + component.$root.siteId + '/';
                }

                $.post(url, postdata, function(originres) {
                    let landscape = component.imageData.originalImage.height < component.imageData.originalImage.width;
                    let scale = 64/component.imageData.originalImage.width;

                    if (landscape) {
                        component.imageData.applyMetadata({
                            startX: 0,
                            startY: 0, 
                            scale: 64/component.imageData.originalImage.height,
                            orientation: 0 
                        });
                    } else {
                        component.imageData.applyMetadata({
                            startX: 0, 
                            startY: 0,
                            scale: 64/component.imageData.originalImage.width,
                            orientation: 0 
                        });
                    }

                    component.customIcon = {
                        'image': originres.url,
                        'imageid': originres.id,
                    }
                }).fail(function() {
                    alert( "Ошибка при сохранении оригинала изображения" );
                }).always(function( data ) {
                    component.$root.unlock();
                });;
            },
            save: function() {
                let component = this;
                let url= "/upload/";

                if (component.$root.siteId) {
                    url = '/upload/' + component.$root.siteId + '/';
                }

                if (component.customIcon && component.imageHasChanged()) {
                    let postdata = {
                        meta: JSON.stringify(component.imageData.getMetadata()), 
                        origin_id: component.customIcon.imageid,
                        file: component.imageData.generateDataUrl('image/png', 0.8)
                    };

                    this.$root.lock();
                    $.post(url, postdata, function(thumbres) {
                        component.customIcon = {
                            ...component.customIcon,
                            'metadata': JSON.stringify(component.imageData.getMetadata()),
                            'thumbnail': thumbres.url,
                        };
                        component.emitChange();
                    }).fail(function() {
                        alert( "Ошибка при загрузке изображения" );
                    }).always(function( data ) {
                        component.$root.unlock();
                    });
                } else {
                    component.emitChange();
                }
            },
            emitChange() {
                this.$emit('change', {
                    index: this.index,
                    type: this.type,
                    size: this.size,
                    icon: this.icon,
                    customIcon: this.customIcon,
                    url: this.url,
                    title: this.title,
                    description: this.description,
                    hashtags: this.hashtags,
                });
            },
            formIsValid() {
                if(!this.icon && !this.customIcon) {
                    return false;
                }

                if(this.urlType != 'auto' && !this.url) {
                    return false;
                }

                return true;
            },
            cancel() {
                this.$emit('close');
            }
        }
    }
</script>

